import React from 'react';
import AssistantContextChip from './AssistantContextChip';

export default function AnalysisContextChip({ state, basis }) {
  if ((!state || state.schema !== 'metric_analysis.v1') && basis?.schema === 'data_basis.v1') {
    if (!basis.label && !basis.clarification) return null;
    return <AssistantContextChip isSnapshot parts={[
      basis.label,
      basis.version ? `${basis.version.name || `Version ${basis.version.id}`} · ${basis.version.status || 'status unverified'}` : null,
      basis.period ? `${basis.period.startDate} – ${basis.period.endDate}` : null
    ]} warning={basis.clarification || null} />;
  }
  if (state?.schema !== 'metric_analysis.v1' || !state.period?.endDate) return null;
  const comparison = { budget: 'vs budget', last_year: 'vs last year' }[state.query?.compareTo];
  const count = state.locationIds?.length || 0;
  const requestedEnd = state.requestedPeriod?.endDate;
  return <AssistantContextChip isSnapshot parts={[
    `${count} ${count === 1 ? 'property' : 'properties'}`,
    state.query?.metric?.replace(/_/g, ' '),
    `${state.period.startDate} – ${state.period.endDate}`,
    comparison,
    state.basis,
    { financial_budget_report_mapping: 'Financial budget · report mapping', labor_budget: 'Labor budget', prior_year_same_basis: 'Same source last year' }[state.comparisonBasis]
  ]} warning={requestedEnd && requestedEnd > state.period.endDate ? `Actuals available through ${state.period.endDate}; comparisons use the same covered dates.` : null} />;
}
